import { SessionStorageKeys } from './session-storage.constants';

type Keys = keyof typeof SessionStorageKeys;

type BaseItemParams = {
    key: Keys
    value?: any
};

type SetItemParams = Required<BaseItemParams>;
type GetItemParams = Omit<BaseItemParams, 'value'>;

const portalApplication = 0;
const getModuleData = () => {
    const storedData = window.sessionStorage.getItem(`${portalApplication}`);

    return storedData ? JSON.parse(storedData) : {};
};

export const setItem = ({
    key, value
}: SetItemParams) => {
    try {
        const moduleData = getModuleData();

        moduleData[key] = value;
        window.sessionStorage.setItem(`${portalApplication}`, JSON.stringify(moduleData));
    } catch (error) {
        console.error(error);
    }
};

export const getItem = ({ key }: GetItemParams) => {
    try {
        const moduleData = getModuleData();

        return moduleData[key];
    } catch (error) {
        console.error(error);
    }
};

export const clearSessionStorage = () => {
    window.sessionStorage.clear();
};
